import {
    PATH as HomePath,
    pageName as HomePageName,
    HOME_GA_CATEGORY,
} from './Home/constants';

import {
    BasePaths as PracticePaths,
    pageName as PracticePageName,
    PRACTICE_GA_CATEGORY,
} from './Practice/constants';

import {
    BasePaths as ProfilePaths,
    pageName as ProfilePageName,
    PROFILE_GA_CATEGORY,
} from './Profile/constants';

import {
    BasePaths as SearchPaths,
    pageName as SearchPageName,
    SEARCH_GA_CATEGORY,
} from './Search/constants';

import {
    BasePaths as SpecialtyDirectoryPaths,
    pageName as SpecialtyDirectoryPageName,
    GA_CATEGORY as SPECIALTY_DIRECTORY_GA_CATEGORY,
} from './SpecialtyDirectory/constants';

import {
    PATH as TelehealthPath,
    pageName as TelehealthProfilePageName,
    TELEHEALTH_PROFILE_GA_CATEGORY,
} from './Telehealth/constants';


export default [
    {
        path: HomePath,
        pageName: HomePageName,
        category: HOME_GA_CATEGORY,
    },

    ...PracticePaths.map(path => ({
        path,
        pageName: PracticePageName,
        category: PRACTICE_GA_CATEGORY,
    })),

    ...ProfilePaths.map(path => ({
        path,
        pageName: ProfilePageName,
        category: PROFILE_GA_CATEGORY,
    })),

    ...SearchPaths.map(path => ({
        path,
        pageName: SearchPageName,
        category: SEARCH_GA_CATEGORY,
    })),

    ...SpecialtyDirectoryPaths.map(path => ({
        path,
        pageName: SpecialtyDirectoryPageName,
        category: SPECIALTY_DIRECTORY_GA_CATEGORY,
    })),

    {
        path: TelehealthPath,
        pageName: TelehealthProfilePageName,
        category: TELEHEALTH_PROFILE_GA_CATEGORY,
    },
];
